import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery, LineItem, LineItemMedia, LineItemContent, LineItemRow, LineItemGlassesPrescription, LineItemBundleRow, Price } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { PricesContainer } from '../containers/PricesContainer.js';
import { RemoveLineItemContainer } from '../containers/RemoveLineItemContainer.js';
import { UpdateLineItemContainer } from '../containers/UpdateLineItemContainer.js';
import { Discount } from '../components/Discount.js';

const BundleLineItem = ({ settings , lineItem , bundleItems , mainBundleItemPrice , cartDiscount , prescription , isLineItemClickable =true  })=>{
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    const { currency , name , price: lineItemPrice , productUrl , imageUrl , quantity  } = lineItem;
    const totalPrice = lineItemPrice.total;
    const totalDiscount = lineItemPrice.total.discount;
    const { readOnly  } = settings;
    const labels = React.useMemo(()=>({
            totalDiscount: getLabel('cart.item.discount'),
            quantity: getLabel('cart.item.quantity')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(LineItem, {
        className: "line-item bundle-line-item"
    }, !isPhone && /*#__PURE__*/ React.createElement("div", {
        className: "line-item__media"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "bundle-line-item__media",
        type: "image",
        href: isLineItemClickable ? productUrl : undefined,
        imageUrl: imageUrl,
        imageAlt: name
    })), /*#__PURE__*/ React.createElement(LineItemContent, {
        className: "bundle-line-item__content"
    }, /*#__PURE__*/ React.createElement(LineItemRow, null, /*#__PURE__*/ React.createElement(LineItemRow.Item, {
        className: "bundle-line-item__title-wrapper"
    }, isPhone && /*#__PURE__*/ React.createElement("div", {
        className: "line-item__media"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        type: "image",
        imageUrl: imageUrl,
        imageAlt: name,
        href: isLineItemClickable ? productUrl : undefined,
        className: "bundle-line-item__media"
    })), /*#__PURE__*/ React.createElement(Heading, {
        className: "bundle-line-item__title",
        variant: "smallest",
        component: "h3"
    }, name)), /*#__PURE__*/ React.createElement("div", {
        className: "bundle-line-item__frame-price-wrapper"
    }, mainBundleItemPrice && /*#__PURE__*/ React.createElement(PricesContainer, {
        discount: mainBundleItemPrice.discount,
        originalPrice: mainBundleItemPrice.original,
        totalPrice: mainBundleItemPrice.gross,
        orientation: isPhone ? 'vertical' : 'horizontal'
    }))), prescription && /*#__PURE__*/ React.createElement(LineItemGlassesPrescription, {
        className: "bundle-line-item__prescription",
        prescription: prescription
    }), bundleItems.map((bundle, idx)=>/*#__PURE__*/ React.createElement(LineItemBundleRow, swcHelpers.extends({
            key: idx
        }, bundle))
    ), readOnly && /*#__PURE__*/ React.createElement(LineItemRow, null, /*#__PURE__*/ React.createElement(LineItemRow.Item, null, labels.quantity, ": ", quantity)), cartDiscount && cartDiscount.amount > 0 && /*#__PURE__*/ React.createElement(LineItemRow, null, /*#__PURE__*/ React.createElement(LineItemRow.Item, {
        className: "bundle-line-item__cart-discount"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "bundle-line-item__cart-discount-text"
    }, cartDiscount.description)), /*#__PURE__*/ React.createElement(Price, {
        value: -cartDiscount.amount,
        currency: currency,
        type: "discount"
    })), /*#__PURE__*/ React.createElement(LineItemRow, null, /*#__PURE__*/ React.createElement(LineItemRow.Item, {
        className: "bundle-line-item__total-price-wrapper"
    }, !readOnly && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "bundle-line-item__delete-btn"
    }, /*#__PURE__*/ React.createElement(RemoveLineItemContainer, {
        lineItem: lineItem
    })), /*#__PURE__*/ React.createElement(UpdateLineItemContainer, {
        lineItem: lineItem
    })), /*#__PURE__*/ React.createElement(PricesContainer, {
        className: "bundle-line-item__total-price",
        discount: 0,
        originalPrice: totalPrice.gross,
        totalPrice: 0
    }))), /*#__PURE__*/ React.createElement(LineItemRow, null, /*#__PURE__*/ React.createElement("span", {
        className: "bundle-line-item__total-discount"
    }, totalDiscount > 0 && /*#__PURE__*/ React.createElement(Discount, {
        absoluteValue: totalDiscount,
        currency: currency,
        labels: {
            discount: labels.totalDiscount
        }
    })))));
};

export { BundleLineItem };
//# sourceMappingURL=BundleLineItem.js.map
